import { FC } from 'react'
import AddBulk from '../../modules/products/AddBulk'

// No useCheckPendingBulk here: that hook gates on the supplier's DISCOUNT
// specials (/special/special) and redirects into /discount/add-discount-bulk,
// so an unfinished connected-barcode discount used to yank suppliers out of
// the product bulk upload and into the discount flow. Unresolved product bulk
// rows are handled by /products/duplicate-barcodes, which is reachable from
// the sidebar and renders "no data" when empty rather than redirecting.
const AddProductBulkPage:FC = () => {
  return (
    <>
        {/* begin::Row */}
        <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        {/* begin::Col */}
        <div className='col-md-12 col-lg-12 mb-md-5 mb-xl-10'>
            <AddBulk />
        </div>
        {/* end::Col */}
        </div>
        {/* begin::Row */}
    </>
  )
}

export default AddProductBulkPage